import React from 'react';
import { UserIcon, UsersIcon } from 'lucide-react';
interface PersonaSwitcherProps {
  persona: 'patient' | 'receptionist';
  setPersona: (persona: 'patient' | 'receptionist') => void;
}
export function PersonaSwitcher({
  persona,
  setPersona
}: PersonaSwitcherProps) {
  return <div className="flex items-center space-x-2 bg-white rounded-lg border border-gray-200 p-1" data-id="element-211">
      <button onClick={() => setPersona('patient')} className={`flex items-center space-x-2 px-4 py-2 rounded-md text-sm font-medium transition-colors ${persona === 'patient' ? 'bg-blue-600 text-white' : 'text-gray-700 hover:bg-gray-100'}`} data-id="element-212">
        <UserIcon className="w-4 h-4" data-id="element-213" />
        <span data-id="element-214">Patient View</span>
      </button>
      <button onClick={() => setPersona('receptionist')} className={`flex items-center space-x-2 px-4 py-2 rounded-md text-sm font-medium transition-colors ${persona === 'receptionist' ? 'bg-blue-600 text-white' : 'text-gray-700 hover:bg-gray-100'}`} data-id="element-215">
        <UsersIcon className="w-4 h-4" data-id="element-216" />
        <span data-id="element-217">Receptionist View</span>
      </button>
    </div>;
}